/**
 * UserSecurityViewElement — blok „Bezpieczeństwo" jako przenośny klocek kreatora
 * layoutu (konfigurowalne zakładki, kartoteka Użytkownicy).
 *
 * Mirror `EmployeeAccountViewElement` — element „widokowy" (panel akcji konta: 2FA,
 * sesje, hasło, strefa zagrożenia — nie tabela kolumn → brak formatki). Na realnej
 * stronie dispatchowany przez `UserDetail` contextRenderers['user_security_view']
 * (→ UserSecurityTab); w builderze stub z rejestru. `allowedModules: ['users']`.
 *
 * `render` wołany jak funkcja — bez hooków w ciele (i18n.t standalone).
 */

import { ShieldCheck } from 'lucide-react';

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';
import i18n from '@/i18n';

export const UserSecurityViewElement: LayoutElementDefinition = {
  type: 'user_security_view',
  category: 'tresc',
  isContainer: false,
  label: 'Bezpieczeństwo',
  icon: 'shield',
  allowedModules: ['users'],
  defaultSettings: () => ({}),
  render: ({ element }) => (
    <div
      className="rounded-lg border border-dashed border-border-secondary bg-bg-secondary p-4 text-center"
      data-testid={`user-security-view-element-${element.id}`}
      data-element-type="user_security_view"
    >
      <ShieldCheck className="mx-auto h-5 w-5 text-text-muted" aria-hidden="true" />
      <p className="mt-1 text-xs font-medium text-text-secondary">
        {i18n.t('tenant.users.securityBlock.paletteLabel', {
          defaultValue: 'Bezpieczeństwo',
        })}
      </p>
    </div>
  ),
};
